export const MERCHANT_TRANSACTIONS_SET = 'merchant_transactions';
export const MERCHANT_BRAND_DOLLARS_SET = 'merchant_brand_dollars';
export const BRANCH_GROUP_BRAND_DOLLARS_SET = 'branchgroup_brandollar_sales';
